import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { identifyCharacter } from '../../actions/CharacterAction';
import { clearRecognizedText } from '../../actions/OcrAction';
import { l10n } from '../../i18n/Localization';
import GameCode from '../../models/games/GameCode';
import CharacterIdentificationConditionsGroup from '../../models/identification_conditions_groups/CharacterIdentificationConditionsGroup';
import BackButton from '../BackButton';
// import ScanButton from '../ScanButton';
import CharacterView from './CharacterView';
import IdentifyCharacterView from './IdentifyCharacterView';

class IdentifyCharacterPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            identifyCharacterStarted: false,
        };

        this.characterIdentificationConditionsGroup = null;

        this.refIdentifyCharacterView = React.createRef();
    }

    createCharacterIdentificationConditionsGroup() {
        const { recognizedText } = this.props;
        const identificationNameOrVerificationNumber = (recognizedText !== null ? recognizedText : '');

        return (new CharacterIdentificationConditionsGroup(GameCode.starcraft2, identificationNameOrVerificationNumber));
    }

    prepareProperties() {
        if (this.characterIdentificationConditionsGroup === null) {
            this.characterIdentificationConditionsGroup = this.createCharacterIdentificationConditionsGroup();
        }
    }

    validateCharacterIdentificationConditionsGroup() {
        return this.refIdentifyCharacterView.current.validate();
    }

    validate() {
        const isCharacterIdentificationConditionsGroupValid = this.validateCharacterIdentificationConditionsGroup();

        if (isCharacterIdentificationConditionsGroupValid) {
            return true;
        } else {
            return false;
        }
    }

    saveCharacterIdentificationConditionsGroup() {
        const characterIdentificationConditionsGroup = this.refIdentifyCharacterView.current.save();

        this.characterIdentificationConditionsGroup = characterIdentificationConditionsGroup;
    }

    save() {
        this.saveCharacterIdentificationConditionsGroup();
    }

    identifyCharacter = () => {
        if (this.validate()) {
            this.save();

            this.setState({
                identifyCharacterStarted: true,
            });

            this.props.identifyCharacter(this.characterIdentificationConditionsGroup);
        }
    }

    render() {
        this.prepareProperties();

        const { identifyCharacterCompleted, identifyCharacterError, characters } = this.props;
        const { identifyCharacterStarted } = this.state;

        let identifyCharacterHint;
        let isIdentifying;

        if (identifyCharacterStarted) {
            if (identifyCharacterCompleted) {
                identifyCharacterHint = (identifyCharacterError !== null) ? identifyCharacterError.message : '';
                isIdentifying = false;
            } else {
                identifyCharacterHint = '';
                isIdentifying = true;
            }
        } else {
            identifyCharacterHint = '';
            isIdentifying = false;
        }

        let actionDiv;

        if (this.characterIdentificationConditionsGroup !== null) {
            actionDiv = (
                <div>
                    {/* <div className="d-flex justify-content-end align-items-center mb-3">
                        <ScanButton disabled={!identifyCharacterCompleted} />
                    </div> */}
                    <div className="d-flex justify-content-end align-items-center">
                        {isIdentifying ? <div className="spinner-border mr-1"></div> : null}
                        <span className="mr-3">{identifyCharacterHint}</span>
                        <button className="btn btn-primary" type="button" onClick={this.identifyCharacter} disabled={!identifyCharacterCompleted}>{l10n.action.identify}</button>
                    </div>
                </div>
            );
        } else {
            actionDiv = null;
        }

        let charactersDiv;

        if (identifyCharacterStarted && identifyCharacterCompleted && identifyCharacterError === null) {
            const characterViewDivs = (characters.length > 0) ? (
                characters.map(character => {
                    return (
                        <div className="mb-3" key={character.id}>
                            <hr className="bg-white" />
                            <CharacterView character={character} showingToOwner={false} />
                        </div>
                    );
                })
            ) : (
                <div className="text-center mb-3">
                    {l10n.identifyCharacterPage.noIdentifiedCharacter}
                </div>
            );

            charactersDiv = (
                <div className="mt-3">
                    {characterViewDivs}
                </div>
            );
        } else {
            charactersDiv = null;
        }

        let content;

        if (this.characterIdentificationConditionsGroup !== null) {
            content = (
                <div className="container mt-3">
                    <div className="d-flex justify-content-between mb-3">
                        <BackButton disabled={!identifyCharacterCompleted} />
                    </div>
                    <div className="mb-3">{l10n.identifyCharacterPage.game}: {this.characterIdentificationConditionsGroup.gameCode.wireName}</div>
                    <IdentifyCharacterView characterIdentificationConditionsGroup={this.characterIdentificationConditionsGroup} ref={this.refIdentifyCharacterView} disabled={!identifyCharacterCompleted} />
                    {actionDiv}
                    {charactersDiv}
                </div>
            );
        } else {
            content = (
                <div className="container mt-3">
                    <div className="d-flex justify-content-center">
                        <div className="spinner-border"></div>
                    </div>
                </div>
            );
        }

        return (
            <div className="IdentifyCharacterPage">
                <Helmet>
                    <link rel="icon" type="image/x-icon" href={`${process.env.PUBLIC_URL}/favicon.ico`} />
                    <meta name="description" content={l10n.identifyCharacterPage.pageTitle} />
                    <title>{l10n.identifyCharacterPage.pageTitle} - {l10n.productName}</title>
                </Helmet>
                {content}
            </div>
        );
    }

    componentDidMount() {
        const { recognizedText } = this.props;

        if (recognizedText !== null) {
            this.props.clearRecognizedText();
        }
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        identifyCharacterCompleted: state.characterState.identifyCharacterCompleted,
        identifyCharacterError: state.characterState.identifyCharacterError,
        characters: state.characterState.identifyCharacterCharacters,
        recognizedText: state.ocrState.recognizedText,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        identifyCharacter: (characterIdentificationConditionsGroup) => {
            dispatch(identifyCharacter(characterIdentificationConditionsGroup));
        },
        clearRecognizedText: () => {
            dispatch(clearRecognizedText());
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(IdentifyCharacterPage);
